// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__3evaB","PageContent":"Page_PageContent__1n88P"};